import type { UniqueIdentifier, DragEndEvent } from "@dnd-kit/core";
import {
  DndContext,
  KeyboardSensor,
  PointerSensor,
  TouchSensor,
  closestCorners,
  useSensors,
  useSensor
} from "@dnd-kit/core";
import {
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
  arrayMove,
  sortableKeyboardCoordinates
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

export const useDndKitProps = ({ id }: { id: string | UniqueIdentifier }) => {
  const {
    attributes,
    listeners,
    transform,
    transition,
    setNodeRef
  } = useSortable({ id });

  const style = {
    transition,
    transform: transform ? CSS.Translate.toString(transform) : undefined
  };

  return {
    attributes,
    listeners,
    style,
    setNodeRef
  }
};